import { render, staticRenderFns } from "./DetailPoint.vue?vue&type=template&id=76d748a2"
import script from "./DetailPoint.vue?vue&type=script&lang=js"
export * from "./DetailPoint.vue?vue&type=script&lang=js"
import style0 from "./DetailPoint.vue?vue&type=style&index=0&id=76d748a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports